'use client';

import { ReactNode, Suspense } from 'react';
import { QueryProvider } from './QueryProvider';
import { PostHogProvider } from './PostHogProvider';
import { AuthProvider } from '@/contexts/AuthContext';
import { Toaster } from '@/components/ui/sonner';
import { TooltipProvider } from '@/components/ui/tooltip';
import { ReferralTracker } from '@/components/ReferralTracker';
import { BrandingProvider } from '@/contexts/BrandingContext';

interface ProvidersProps {
  children: ReactNode;
}

export function Providers({ children }: ProvidersProps) {
  return (
    <QueryProvider>
      <Suspense fallback={null}>
        <PostHogProvider>
          <AuthProvider>
            <ReferralTracker />
            <BrandingProvider>
              <TooltipProvider>
                {children}
                <Toaster />
              </TooltipProvider>
            </BrandingProvider>
          </AuthProvider>
        </PostHogProvider>
      </Suspense>
    </QueryProvider>
  );
}
